module.exports = __webpack_public_path__ + "img/icon-umbrella.8e29d612.png";